/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Market_Data_DescriptionInputs */

const en_landing_capability_market_data_description = /** @type {(inputs: Landing_Capability_Market_Data_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentic AI is only as good as the data it can reach. Inginuiti securely bridges your proprietary research with real-time global market signals.`)
};

/**
* | output |
* | --- |
* | "Agentic AI is only as good as the data it can reach. Inginuiti securely bridges your proprietary research with real-time global market signals." |
*
* @param {Landing_Capability_Market_Data_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_market_data_description = /** @type {((inputs?: Landing_Capability_Market_Data_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Market_Data_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_market_data_description(inputs)
});